import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import MainTable from "../../../../components/MainTable";
import api from "../../../../services/api";
import { Title } from "../../../../styles/global";
import { useAuth } from "../../../../hooks/auth";
import getPermission from "../../../../utils/getPermission";

const OrigemDemanda: React.FC = () => {
  const [origensDemanda, setOrigensDemanda] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const {login} = useAuth();
  const protocoloPermission = getPermission(login,"Protocolo") ?? '';

  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      api
        .get(`demand_origins?busca_rapida=${searchValue}`)
        .then((response) => {
          setOrigensDemanda(response.data);
        })
        .catch((error) => console.log(error));
    }, 500);

    return () => clearTimeout(delayedSearch);
  }, [searchValue]);

  const handlePagination = (goBack = false) => {
    const page = goBack ? -1 : 1;

    api
      .get(`demand_origins?page=${origensDemanda.pagination.current_page + page}`)
      .then((response) => {
        setOrigensDemanda(response.data);
      })
      .catch((error) => console.log(error));
  };

  const columnData = [
    { headerName: "Código", field: "id" },
    { headerName: "Origem da Demanda", field: "nome" },
    { headerName: "Situação", field: "ativo" },
  ];

  const organizeData = (data: any) => {
    if (typeof data === "object") {
      data = data.map((d: any) => ({
        id: d.id,
        nome: d.nome,
        ativo: d.ativo,
      }));
    }

    return data;
  };

  return (
    <>
      <Title color="#333">
        <span>Gestão de Origem da demanda</span>
      </Title>
      <Container color="#FFF">
        <MainTable
          onSearchChange={setSearchValue}
          data={organizeData(origensDemanda.data)}
          pagination={origensDemanda.pagination}
          permission={protocoloPermission}
          hideCreate={protocoloPermission == "Visitante"}
          handlePagination={handlePagination}
          hideFilter={true}
          isMaxWidthCell
          registerLink="/protocolo/cadastros/origem_demanda/cadastrar"
          columns={columnData}
          dropdown={{
            view: { linkTo: "/protocolo/cadastros/origem_demanda/visualizar" },
            editar: { linkTo: "/protocolo/cadastros/origem_demanda/editar" },
            desativar: { linkTo: "demand_origins" },
          }}
        />
      </Container>
    </>
  );
};

export default OrigemDemanda;
